import { render, staticRenderFns } from "./IpLogins.vue?vue&type=template&id=04e2c348&scoped=true&"
import script from "./IpLogins.vue?vue&type=script&lang=js&"
export * from "./IpLogins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e2c348",
  null
  
)

export default component.exports